export * from './delete-erforderliches-dokument.command.module';
export * from './service';
export * from './component';